var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 8.33317H5.83341C7.50008 8.33317 8.33341 7.49984 8.33341 5.83317V4.1665C8.33341 2.49984 7.50008 1.6665 5.83341 1.6665H4.16675C2.50008 1.6665 1.66675 2.49984 1.66675 4.1665V5.83317C1.66675 7.49984 2.50008 8.33317 4.16675 8.33317Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 8.33317H15.8334C17.5001 8.33317 18.3334 7.49984 18.3334 5.83317V4.1665C18.3334 2.49984 17.5001 1.6665 15.8334 1.6665H14.1667C12.5001 1.6665 11.6667 2.49984 11.6667 4.1665V5.83317C11.6667 7.49984 12.5001 8.33317 14.1667 8.33317Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3332H15.8334C17.5001 18.3332 18.3334 17.4998 18.3334 15.8332V14.1665C18.3334 12.4998 17.5001 11.6665 15.8334 11.6665H14.1667C12.5001 11.6665 11.6667 12.4998 11.6667 14.1665V15.8332C11.6667 17.4998 12.5001 18.3332 14.1667 18.3332Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 18.3332H5.83341C7.50008 18.3332 8.33341 17.4998 8.33341 15.8332V14.1665C8.33341 12.4998 7.50008 11.6665 5.83341 11.6665H4.16675C2.50008 11.6665 1.66675 12.4998 1.66675 14.1665V15.8332C1.66675 17.4998 2.50008 18.3332 4.16675 18.3332Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.0d8ca12ee5c7ede4f871e00beae8d961.svg";
export { ForwardRef as ReactComponent };